import {
  MainTable5SState,
  MainTable5SActions,
  MainTable5SActionTypes,
} from '../../types/mainTable5S';

const initialState: MainTable5SState = {
  table: { data: null, loading: false, error: null },
  editCard: { data: null, loading: false, error: null },
  deleteCard: { loading: false, error: null, lastDeletedId: null },
};

export const mainTable5S = (state = initialState, action: MainTable5SActions): MainTable5SState => {
  switch (action.type) {
    case MainTable5SActionTypes.LOAD_TABLE_REQUEST:
      return { ...state, table: { ...state.table, loading: true, error: null } };

    case MainTable5SActionTypes.LOAD_TABLE_SUCCESS:
      return { ...state, table: { data: action.payload.data, loading: false, error: null } };

    case MainTable5SActionTypes.LOAD_TABLE_FAILURE:
      return { ...state, table: { ...state.table, loading: false, error: action.payload.error } };

    case MainTable5SActionTypes.LOAD_EDIT_CARD_REQUEST:
      return { ...state, editCard: { data: null, loading: true, error: null } };

    case MainTable5SActionTypes.LOAD_EDIT_CARD_SUCCESS:
      return { ...state, editCard: { data: action.payload.data, loading: false, error: null } };

    case MainTable5SActionTypes.LOAD_EDIT_CARD_FAILURE:
      return { ...state, editCard: { data: null, loading: false, error: action.payload.error } };

    case MainTable5SActionTypes.CLEAR_EDIT_CARD:
      return { ...state, editCard: { data: null, loading: false, error: null } };

    case MainTable5SActionTypes.DELETE_CARD_REQUEST:
      return { ...state, deleteCard: { ...state.deleteCard, loading: true, error: null } };

    case MainTable5SActionTypes.DELETE_CARD_SUCCESS:
      return { ...state, deleteCard: { loading: false, error: null, lastDeletedId: action.payload.id } };

    case MainTable5SActionTypes.DELETE_CARD_FAILURE:
      return { ...state, deleteCard: { ...state.deleteCard, loading: false, error: action.payload.error } };

    default:
      return state;
  }
};
